/** Size variant of a `compsych-dropdown`. Controls trigger height, padding, and font size. */
export type DropdownSize = 'small' | 'medium' | 'large';

/** A single selectable option in a `compsych-dropdown`. */
export interface DropdownOption {
  /** Value written to the bound form control / emitted by `valueChange`. */
  value: string;
  /** Text shown for the option in the panel and, when selected, in the trigger. */
  label: string;
  /** Prevents the option from being selected or focused. */
  disabled?: boolean;
}
